import customURLSearchParams from "services/CustomURLSearchParams";
import { isLoadingAtomBool, originalDataAtomObject } from "../state";
import { useAtom } from "jotai";
import { useEffect } from "react";


const usePromoBanner = () => {

  const [isLoading] = useAtom(isLoadingAtomBool);
  const [originalData] = useAtom(originalDataAtomObject);


  const promoBanner = () => {
    const dynamicJobSearch = document.getElementById(
      "vennture_dynamic_jobsearch"
    );
    const featureInserts = document.querySelectorAll(".feature-insert");

    Array.from(featureInserts).find((featureInsert) => {
      featureInsert.style.display = "none";
      dynamicJobSearch.insertAdjacentElement("afterend", featureInsert);
      return true;
    });

    const matchingElements = Array.from(featureInserts).filter(
      (featureInsert) => {
        return (
          featureInsert.dataset.match !== "" && featureInsert.dataset.match
        );
      }
    );

    let foundMatchingElement = false;

    const noMatchElement = Array.from(featureInserts).filter(
      (featureInsert) => {
        return (
          featureInsert.dataset.match === "" || !featureInsert.dataset.match
        );
      }
    );

    matchingElements.forEach((featureInsert, index) => {
      featureInsert.style.display = "none";
      dynamicJobSearch.insertAdjacentElement("afterend", featureInsert);
      const jobsList = document.querySelector(".job-listing");
      const placementMatch = featureInsert.dataset.match
        .toLowerCase()
        .replace(/(\w+)\s+(\w+)/g, "$1+$2")
        .replace(/\s+(?![\w-])/g, "");

      const placementOrder = featureInsert.dataset.placement;
      let encodedPlacementMatch = "";
      const params = customURLSearchParams().toString();
      const lowerCaseParams = params.toLowerCase();
      if (placementMatch) {
        encodedPlacementMatch = placementMatch.replace(/\s/g, "");

      }

      if (
        jobsList &&
        !isLoading &&
        originalData.totalCount > 0 &&
        (encodedPlacementMatch === "" || encodedPlacementMatch.includes(",")
          ? encodedPlacementMatch
            .split(",")
            .some((param) => lowerCaseParams.includes(param))
          : lowerCaseParams.includes(encodedPlacementMatch))
      ) {
        jobsList.insertBefore(
          featureInsert,
          jobsList.childNodes[placementOrder - 1]
        );
        setTimeout(function () {

          featureInsert.style.display = "block";
        }, 80);
        foundMatchingElement = true;
      }
    });

    if (!foundMatchingElement) {
      noMatchElement.forEach((featureInsert, index) => {
        featureInsert.style.display = "none";
        dynamicJobSearch.insertAdjacentElement("afterend", featureInsert);
        const jobsList = document.querySelector(".job-listing");

        const placementOrder = featureInsert.dataset.placement;
        let encodedPlacementMatch = "";
        const params = customURLSearchParams().toString();
        const lowerCaseParams = params.toLowerCase();

        if (
          jobsList &&
          !isLoading &&
          originalData.totalCount > 0 &&
          (encodedPlacementMatch === "" ||
            !lowerCaseParams.includes(encodedPlacementMatch))
        ) {
          jobsList.insertBefore(
            featureInsert,
            jobsList.childNodes[placementOrder - 1]
          );

          setTimeout(function () {
            featureInsert.style.display = "block";
          }, 80);
          foundMatchingElement = true;
        }
      });
    }
  };

  useEffect(() => {
    promoBanner();
  }, [isLoading]);

}

export default usePromoBanner;